import React from 'react';
import { createGlobalStyle } from 'styled-components';

// Import polyfills via require in browser context
if (typeof window !== 'undefined') {
  require('../polyfills/promise-polyfills');
}

const GlobalStyle = createGlobalStyle`
  /* Font import moved to SEO component */

  *, html, body {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    vertical-align: baseline;
    font-family: "DM Sans", sans-serif;
    font-weight: 400;
  }

  html,
  body {
    overflow-x: hidden;
    height: 100%;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: "PP Agrandir", sans-serif;
    font-weight: 400;
  }

  strong {
    font-weight: 500;
  }

  #app {
    width: 100%;
  }

  .accordion-card ul {
    list-style-type: disc;
    list-style-position: outside;
    margin-left: 1.2rem;
  }

  .accordion-card li {
    margin-bottom: 0.5rem;
    color: #545454;
    font-size: 16px;
    line-height: 1.5;
  }

  .accordion-description ul {
    list-style-type: disc !important;
    list-style-position: outside;
    margin-left: 1.2rem;
    padding: 5px 0;
  }

  .accordion-description li {
    color: #545454;
    font-size: 16px;
    line-height: 1.25;
    display: list-item !important;
  }

  .accordion-description li p {
    margin-bottom: 0 !important;
  }

  #product-details ul {
    list-style-type: disc !important;
    list-style-position: outside;
    margin-left: 1.75rem;
  }

  .react-pdf__Page,
  .react-pdf__Page__canvas {
    width: 100% !important;
    height: auto !important;
    box-shadow: none !important;
  }

  #product-tab-content .chakra-text p:nth-child(1) {
    padding-bottom: 8px;
  }

  .accordion-description p {
    margin-bottom: 20px;
    font-size: 16px;
  }

  #product-tab-content h3 {
    margin-top: 0 !important;
  }

  #product-tab-content p {
    font-size: 16px;
  }
`;

// This file doesn't export any React component, but wraps global styles
// in a React element to comply with Gatsby's expectations
export default function GlobalStylesWrapper() {
  return <GlobalStyle />;
}
